import './Badge.scss';

import PropTypes from 'prop-types';
import React from 'react';

import cx from 'utils/cx';

const Badge = ({ color, children }) => (
  <span className={cx('badge', color)}>{children}</span>
);

Badge.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Badge.defaultProps = {
  color: 'primary',
};

export default Badge;
